var _jsxFileName = "/src/main/react/src/main/app/index.js";
import React, { Component } from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import ReactDOM from 'react-dom';
import './index.css';
import { BrowserRouter as Router } from "react-router-dom";
import { MuiThemeProvider } from '@material-ui/core/styles';
import { createMuiTheme } from '@material-ui/core/styles/index';
import { CookiesProvider } from "react-cookie";
import App from "./components/App";
export const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#337ab7'
    },
    secondary: {
      main: '#fafafa'
    }
  }
});
ReactDOM.render(/*#__PURE__*/React.createElement(CookiesProvider, {
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 23,
    columnNumber: 5
  }
}, /*#__PURE__*/React.createElement(MuiThemeProvider, {
  theme: theme,
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 24,
    columnNumber: 9
  }
}, /*#__PURE__*/React.createElement(CssBaseline, {
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 25,
    columnNumber: 13
  }
}), /*#__PURE__*/React.createElement(Router, {
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 26,
    columnNumber: 13
  }
}, /*#__PURE__*/React.createElement(App, {
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 27,
    columnNumber: 17
  }
})))), document.getElementById('root'));